import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { ExamsResolutionCardAttemptItem } from './exams-resolution-card-attempt-item';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import { Loader } from '@/components/custom/loader';
import { AttemptCardWrapper, AttemptCard as AttCard, AttemptCardTitle } from '@/components/custom/attempt';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export function ExamsResolutionCardAttempt(props) {
  const { index, attemptData } = props;

  const { t } = useTranslation();
  const client = useClient();
  const [active, setActive] = useState(false);
  const [studentAnswers, setStudentAnswers] = useState();
  const [questions, setQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const currentTime = Date.now();
  const finishDateMillis = new Date(attemptData['finished-at']).getTime();

  const getStudentAnswers = async () => {
    const { data, error } = await client.fetch(`question_books_users/${attemptData.id}/answers`);
    if (error) {
      if (error?.id === 'base') {
        toast.error(error?.title);
      } else {
        toast.error('Erro ao obter informações desta prova'); //default
      }
    } else {
      setStudentAnswers(data);
    }
  };

  const getQuestions = async () => {
    const { data, error } = await client.fetch(`questions?filter[question_book_id]=${attemptData['question-book-id']}`);
    if (error) {
      toast.error('Erro ao buscar alternativas');
    } else {
      setQuestions(data);
    }
  };

  const handleGetStudentAnswers = async () => {
    if (!active) {
      Promise.all([getStudentAnswers(), getQuestions()]).finally(() => setIsLoading(false));
    }

    setActive(prev => !prev);
  };

  return (
    <AttemptCardWrapper style={{ paddingBottom: active ? '20px' : '0' }}>
      <AttCard onClick={handleGetStudentAnswers}>
        <AttemptCardTitle>{attemptData.attempt}º Tentativa</AttemptCardTitle>
        <span>{moment(attemptData?.['finished-at']).format('DD/MM/YYYY')}</span>
        <span>
          Nota <b className="text-primary">{attemptData?.score && !isNaN(parseFloat(attemptData.score).toFixed(2)) && attemptData.done ? parseFloat(attemptData.score).toFixed(2) : '--'}</b>
        </span>

        {index === 0 ? (
          currentTime < finishDateMillis ? (
            <Badge
              size="xs"
              variant="amber-soft"
            >
              {t('exams.statusInAnalysis')}
            </Badge>
          ) : attemptData.status === 'approved' ? (
            <Badge
              size="xs"
              variant="success-soft"
            >
              {t('exams.statusInApproved')}
            </Badge>
          ) : attemptData.status === 'disapproved' ? (
            <Badge
              size="xs"
              variant="danger-soft"
            >
              {t('exams.statusInDisapproved')}
            </Badge>
          ) : null
        ) : (
          <div className="w-[68px]" />
        )}

        {active ? (
          <FiChevronUp
            className="text-primary"
            size={20}
          />
        ) : (
          <FiChevronDown
            className="text-primary"
            size={20}
          />
        )}
      </AttCard>

      {active && (
        <div className="border-t border-solid border-neutral-lightest">
          <div className="mt-5">
            {isLoading ? (
              <Loader />
            ) : (
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead
                      scope="col"
                      className="whitespace-normal !border-0 !shadow-none"
                    >
                      {t('exams.tableHeaderQuestionId')}
                    </TableHead>
                    <TableHead
                      scope="col"
                      className="whitespace-normal !border-0 !shadow-none"
                    >
                      {t('exams.tableHeaderAnswerKey')}
                    </TableHead>
                    <TableHead
                      scope="col"
                      className="whitespace-normal !border-0 !shadow-none"
                    >
                      {t('exams.tableHeaderStudentResponse')}
                    </TableHead>
                    <TableHead
                      scope="col"
                      className="whitespace-normal !border-0 !shadow-none"
                    >
                      {t('exams.tableHeaderStudentResult')}
                    </TableHead>
                    <TableHead
                      scope="col"
                      className="whitespace-normal !border-0 !shadow-none"
                    >
                      {t('exams.tableHeaderOverallPerformace')}
                    </TableHead>
                    <TableHead
                      scope="col"
                      className="w-12 whitespace-normal !border-0 !shadow-none"
                    />
                  </TableRow>
                </TableHeader>

                <TableBody>
                  {studentAnswers?.['with-alternatives'].map(item => {
                    const currentQuestion = questions?.find(q => q.id === item['question_id']);

                    return (
                      <ExamsResolutionCardAttemptItem
                        key={item.id}
                        studentAnswers={item}
                        currentQuestion={currentQuestion}
                        feedback={item?.student_alternative?.name === '3' ? 'blank' : item?.correct_alternative?.id === item?.student_alternative?.id ? 'positive' : 'negative'}
                      />
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </div>
        </div>
      )}
    </AttemptCardWrapper>
  );
}
